import React, { useMemo, useEffect } from "react";
import { FormGroup, Label, Input } from "reactstrap";
import { GetFieldsList } from "components/Utils";
import { QueryFields } from "data/Types";
import { useSearchQuery } from "hooks";
import styles from "./BasicFilters.module.css";

const BasicFilters = () => {
  const [query, setQuery] = useSearchQuery();
  const toggleField = (field) => {
    let fields = query.fields;
    if (fields & QueryFields[field]) {
      fields &= ~QueryFields[field];
    } else {
      fields |= QueryFields[field];
    }
    setQuery({ fields });
  };
  const availableFields = GetFieldsList(QueryFields[query.type], false);
  const allowedFields = useMemo(() => {
    let fields = query.fields;
    for (let field of GetFieldsList(query.fields, false)) {
      if (!(QueryFields[query.type] & QueryFields[field.key])) {
        console.warn(
          `QueryFields OutOfRange: Removing not allowed filter ${field.key} from query`
        );
        fields &= ~QueryFields[field.key];
      }
    }
    return fields;
  }, [query.fields, query.type]);
  useEffect(() => {
    if (allowedFields !== query.fields) {
      setQuery({ fields: allowedFields });
    }
  }, [allowedFields, query.fields, setQuery]);
  return availableFields.map((field, i) => (
    <FormGroup className={styles.filter} check key={`basic-filter-${i}`}>
      <Label check>
        <Input
          onChange={() => toggleField(field.key)}
          type="checkbox"
          checked={!!(query.fields & QueryFields[field.key])}
        />{" "}
        {field.label}
      </Label>
    </FormGroup>
  ));
};

export { BasicFilters };
